"use client";
import { produce } from "immer";
import { useCallback } from "react";
import { useLanguage } from "../../translations/LocalizationProvider.js";
import "../validation/validators.js";
import { getValidationMessage } from "../validation/validation.js";
function useFormHelpers(form, validators, setField, setBlurred) {
  const lang = useLanguage();
  const setValue = useCallback((field) => (value) => setField([field, value]), [setField]);
  return {
    setValue,
    inputProps: (field) => {
      var _a;
      return {
        value: form.raw[field],
        setValue: setValue(field),
        ...form.showError[field] && !((_a = form.validation[field]) == null ? void 0 : _a.isValid) && {
          validity: {
            type: "error",
            message: getValidationMessage(form.validation[field], validators[field].messagePrefix, lang)
          }
        },
        onBlur: () => setBlurred(field)
      };
    }
  };
}
const makePropertySetter = (formValidator) => (state, [property, value]) => {
  const raw = produce(state.raw, (draft) => {
    draft[property] = value;
  });
  const result = formValidator(raw);
  const showError = produce(state.showError, (draft) => {
    var _a;
    if ((_a = result.validation[property]) == null ? void 0 : _a.showMessageImmediately) {
      draft[property] = true;
    } else {
      draft[property] = false;
    }
  });
  return {
    ...state,
    ...result,
    raw,
    showError
  };
};
const makeBlurSetter = () => (state, property) => produce(state, (draft) => {
  const rawValue = draft.raw[property];
  if (typeof rawValue === "string" && rawValue.length >= 1 || typeof rawValue !== "string" && rawValue !== void 0) {
    draft.showError[property] = true;
  }
});
export {
  makeBlurSetter,
  makePropertySetter,
  useFormHelpers
};
